module.exports = __webpack_public_path__ + "img/ccb-server.3feaeb43.png";